import { useEffect, useRef, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";

/**
 * StripeInlinePayment — white-labeled inline mount.
 * Renders Stripe Embedded Checkout on the checkout page with minimal external
 * chrome. Stripe's own "Powered by Stripe" footer (inside the iframe) is kept
 * per Stripe ToS. Everything OUTSIDE the iframe is Aminoplex.
 */
export default function StripeInlinePayment({ publishableKey, clientSecret, onBack }) {
    const stripePromise = useRef(null);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        if (!publishableKey) return;
        stripePromise.current = loadStripe(publishableKey);
        setReady(true);
    }, [publishableKey]);

    if (!ready || !clientSecret) {
        return (
            <div className="py-14 text-center" data-testid="stripe-inline-loading">
                <div className="inline-flex items-center gap-3 data-label text-muted">
                    <div className="w-2 h-2 rounded-full bg-[var(--brand)] animate-pulse" />
                    Preparing secure payment…
                </div>
            </div>
        );
    }

    return (
        <div data-testid="stripe-inline-payment">
            <EmbeddedCheckoutProvider stripe={stripePromise.current} options={{ clientSecret }}>
                <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
            {onBack && (
                <div className="mt-4 text-center">
                    <button
                        type="button"
                        onClick={onBack}
                        className="data-label text-[0.65rem] text-muted hover:text-[var(--brand)] transition"
                        data-testid="stripe-back"
                    >
                        ← Use a different payment method
                    </button>
                </div>
            )}
        </div>
    );
}
